import React, { useState } from "react";
import { Link, NavLink, ScrollRestoration } from "react-router-dom";
import { FaUserCircle } from "react-icons/fa";
import { useContext } from "react";
import { AuthContext } from "../../../contexts/AuthProvider/AuthProvider";
import { PhotoProvider, PhotoView } from "react-photo-view";
import { LazyLoadImage } from "react-lazy-load-image-component";
import logo from "../../../assets/logo/logo.png";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { HiBars3BottomRight } from "react-icons/hi2";
import "./Header.css";

const Header = () => {
  const { user, logOut } = useContext(AuthContext);
  console.log("user:", user);

  const [toggle, setToggle] = useState(false);

  let activeStyle = {
    color: "#89e9e9",
    fontWeight: "700",
    fontSize: "17.5px",
  };

  const handleLogout = () => {
    logOut()
      .then(() => { })
      .catch((error) => console.error(error));
  };

  return (
    <nav className="navbar navbar-expand-lg nav-bg navbar-dark mb-5 sticky-to fw-header">
      <div className="container-fluid">
        <Link className="navbar-brand fw-bold" to="/">
          <div className="d-flex justify-content-center align-items-center">
            <img
              src={logo}
              alt="logo"
              height="30px"
              className="bg-white rounded p-1"
            />
            <span className="ms-2 path">Food For You</span>
          </div>
        </Link>

        <div
          className="navbar-toggle text-white d-lg-none"
          // type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarText"
          aria-controls="navbarText"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <div
            className="d-flex justify-content-center align-items-center toggle-icon"
            onClick={() => setToggle(!toggle)}
          >
            {toggle ? (
              <span className=" toggle-icon1" title="Close Menu">
                <IoIosCloseCircleOutline />
              </span>
            ) : (
              <span className="fs- toggle-icon2" title="Open Menu">
                <HiBars3BottomRight />
              </span>
            )}
          </div>
        </div>

        <div className="collapse navbar-collapse" id="navbarText">
          <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
            <li className="nav-item mx-1 mt-2 mt-lg-0">
              <NavLink
                className="nav-link active"
                aria-current="page"
                to="/home"
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
              >
                <ScrollRestoration />
                Home
              </NavLink>
            </li>
            <li className="nav-item mx-1">
              <NavLink
                className="nav-link active"
                to="/services"
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
              >
                Services
              </NavLink>
            </li>
            <li className="nav-item mx-1">
              <NavLink
                className="nav-link active"
                to="/blog"
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
              >
                Blogs
              </NavLink>
            </li>

            <li className="nav-item fs-6 text-white mt-1 mt-lg-0 mb-2 mb-lg-0">
              <NavLink
                className="nav-link active ms-1 ms-lg-0"
                to="/add-service"
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
              >
                Add Service
              </NavLink>
            </li>

            {/* {user?.uid && ( */}
            <li className="nav-item fs-6 text-white mt-my-reviews mt-lg-0 mb-2 mb-lg-0">
              <NavLink
                className="nav-link active ms-1 ms-lg-0"
                to="/my-reviews"
                style={({ isActive }) => (isActive ? activeStyle : undefined)}
              >
                My Reviews
              </NavLink>
            </li>
          </ul>

          <li className="nav-item mx-1 d-flex align-items-center">
            <div className="log-in">
              {user?.uid ? (
                <div className="d-flex-col d-lg-flex">
                  <small className="ms-0 me-3 hi-header fw-bold mt-0 mt-md-1">
                    {user?.displayName}
                  </small>

                  <Link
                    className="nav-link active fw-bold log-in text-white me-2 mt-2 mt-md-0 mb-3 mb-lg-0 log-out "
                    to="/login"
                    onClick={handleLogout}
                  >
                    Logout
                  </Link>
                </div>
              ) : (
                <NavLink
                  className="nav-link active fw-bold log-in text-white me-2"
                  to="/login"
                  style={({ isActive }) => (isActive ? activeStyle : undefined)}
                >
                  Login
                </NavLink>
              )}
            </div>
          </li>

          <span className="navbar-text borde mt-0 mb-log-photo">
            <Link className="navbar-brand me-0" to="/">
              {user?.photoURL ? (
                <div className="d-flex justify-content-lg-center align-items-center ms-2 ms-lg-0">
                  <PhotoProvider
                    speed={() => 800}
                    easing={(type) =>
                      type === 2
                        ? "cubic-bezier(0.36, 0, 0.66, -0.56)"
                        : "cubic-bezier(0.34, 1.56, 0.64, 1)"
                    }
                  >
                    <PhotoView src={user?.photoURL}>
                      <figure>
                        <LazyLoadImage
                          src={user?.photoURL}
                          alt={user?.displayName}
                          className="d-inline-block align-text-top rounded-2 mb-0"
                          width="30"
                          height="32"
                          placeholderSrc={user?.photoURL}
                          effect="blur"
                          title={user?.displayName}
                          style={{ objectFit: "cover", cursor: "pointer" }}
                        />
                      </figure>
                    </PhotoView>
                  </PhotoProvider>
                </div>
              ) : (
                <div className="d-flex justify-content-lg-center align-items-center mb-log-icon">
                  <FaUserCircle className="fs-3 ms-2 ms-lg-0 fs-lg-3 mt-4 mt-lg-0 mb-3 mb-lg-0 pb-cu h-fa-user"></FaUserCircle>
                </div>
              )}
            </Link>
          </span>
        </div>
      </div>
    </nav>
  );
};

export default Header;
